import { CUIVStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { trackPageview } from '../utils/usageTracker';
import HomepageLayout from './layout/Homepage/HomepageLayout';
import SignupButton from './AuthButtons/SignupButton';
import HomepageCard from './HomepageCard/HomepageCard';
import HomepageCardDescriptionSection from './HomepageCard/HomepageCardDescriptionSection';
import HomepageCardImageSection from './HomepageCard/HomepageCardImageSection';
import HomepageMemberHighlight from './HomepageMemberHighlight/HomepageMemberHighlight';
import HomepageCta from './HomepageCard/HomepageCta';

// @ts-expect-error ts-migrate(7016) NOFIX
import careerImage from 'bender-url!../../images/homepageCardImages/homepage-card-career.webp';
// @ts-expect-error ts-migrate(7016) NOFIX
import expertiseImage from 'bender-url!../../images/homepageCardImages/homepage-card-expertise.webp';
// @ts-expect-error ts-migrate(7016) NOFIX
import discoverImage from 'bender-url!../../images/homepageCardImages/homepage-card-discover.webp';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function HomepageContent() {
  useEffect(() => {
    trackPageview('homepage');
  }, []);
  return /*#__PURE__*/_jsx(HomepageLayout, {
    children: /*#__PURE__*/_jsxs(CUIVStack, {
      spacing: 0,
      "data-test-id": "homepage-card-stack",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "HOME_LOAD"
      }), /*#__PURE__*/_jsx(HomepageMemberHighlight, {}), /*#__PURE__*/_jsx(HomepageCard, {
        "data-test-id": "homepage-card",
        mediaSide: "right",
        bgColor: "SOLARIS.extraLight",
        media: /*#__PURE__*/_jsx(HomepageCardImageSection, {
          mediaSide: "right",
          src: discoverImage,
          alt: I18n.text('app.homepage.cards.discover.imgAlt'),
          bgColor: "SOLARIS.extraLight"
        }),
        description: /*#__PURE__*/_jsx(HomepageCardDescriptionSection, {
          bgColor: "SOLARIS.extraLight",
          color: "GREYSCALE.DARK_MATTER",
          mediaSide: "right",
          cta: /*#__PURE__*/_jsx(SignupButton, {
            bgGradient: "var(--chakra-gradients-magenta-orange)",
            border: "none",
            color: "GREYSCALE.MOON",
            trackingIdentifier: "discover-card",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.homepage.cards.discover.cta"
            })
          }),
          headingText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.homepage.cards.discover.title"
          }),
          bodyText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.homepage.cards.discover.bodyText"
          })
        })
      }), /*#__PURE__*/_jsx(HomepageCard, {
        bgColor: "GREYSCALE.MOON",
        "data-test-id": "homepage-card",
        mediaSide: "left",
        media: /*#__PURE__*/_jsx(HomepageCardImageSection, {
          mediaSide: "left",
          src: expertiseImage,
          alt: I18n.text('app.homepage.cards.expertise.imgAlt'),
          bgColor: "GREYSCALE.MOON"
        }),
        description: /*#__PURE__*/_jsx(HomepageCardDescriptionSection, {
          bgColor: "GREYSCALE.MOON",
          mediaSide: "left",
          color: "GREYSCALE.DARK_MATTER",
          cta: /*#__PURE__*/_jsx(SignupButton, {
            bgGradient: "var(--chakra-gradients-magenta-orange)",
            border: "none",
            color: "GREYSCALE.MOON",
            trackingIdentifier: "expertise-card",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.homepage.cards.expertise.cta"
            })
          }),
          headingText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.homepage.cards.expertise.title"
          }),
          bodyText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.homepage.cards.expertise.bodyText"
          })
        })
      }), /*#__PURE__*/_jsx(HomepageCard, {
        bgColor: "SOLARIS.extraLight",
        "data-test-id": "homepage-card",
        mediaSide: "right",
        media: /*#__PURE__*/_jsx(HomepageCardImageSection, {
          mediaSide: "right",
          src: careerImage,
          alt: I18n.text('app.homepage.cards.career.imgAlt'),
          bgColor: "SOLARIS.extraLight"
        }),
        description: /*#__PURE__*/_jsx(HomepageCardDescriptionSection, {
          bgColor: "SOLARIS.extraLight",
          color: "GREYSCALE.DARK_MATTER",
          mediaSide: "right",
          cta: /*#__PURE__*/_jsx(SignupButton, {
            bgGradient: "var(--chakra-gradients-magenta-orange)",
            border: "none",
            color: "GREYSCALE.MOON",
            trackingIdentifier: "career-card",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "app.homepage.cards.career.cta"
            })
          }),
          headingText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.homepage.cards.career.title"
          }),
          bodyText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.homepage.cards.career.bodyText"
          })
        })
      }), /*#__PURE__*/_jsx(HomepageCta, {})]
    })
  });
}